import { createSlice } from '@reduxjs/toolkit';
import { fetchPromotionsApi, deletePromotionApi } from '../../api/promotions';
import {
  createAsyncAction,
  createAsyncReducerHandlers,
  asyncInitialState as initialState,
  fetchPageAsyncReducerHandler,
} from '../utils/async';

export const fetchPromotions = createAsyncAction('fetch-promotions', fetchPromotionsApi);
export const fetchPromotionsPage = createAsyncAction('fetch-promotions-page', fetchPromotionsApi);

const promotionsSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    clearPromotions(state) {
      delete state.data;
    },
  },
  extraReducers: {
    ...createAsyncReducerHandlers(fetchPromotions),
    ...fetchPageAsyncReducerHandler(fetchPromotionsPage),
  },
});

export const { clearPromotions } = promotionsSlice.actions;
export const { reducer: promotions } = promotionsSlice;

export const deletePromotion = createAsyncAction('delete-promotion', deletePromotionApi);

const adjustmentSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    clearPromotion(state) {
      delete state.data;
    },
  },
  extraReducers: {
    ...createAsyncReducerHandlers(deletePromotion),
  },
});

export const { clearPromotion } = adjustmentSlice.actions;
export const { reducer: promotion } = adjustmentSlice;
